var React = require('react');
var ReactRouter = require('react-router');
var Link = ReactRouter.Link;
var Shopify = require('./shopify');
var Utils = require('./utils');
var PostRow = require('./post-row');
var HeaderPage = require('./header-page');
var ScrollToTop = require('./scroll-to-top');

module.exports = React.createClass({

  mixins: [ ScrollToTop ],
  relatedForStyleTip: null,
  relatedForSaleEvent: null,
  
  getInitialState: function() {
    return { postTitle: "" }
  },

  componentDidMount: function() {
    document.title = "Ingledew's Shoes - Blog";

    this.scrollToTop('blog-page');

    Shopify.getBlog("style-tips", this.styleTipsGot);
    Shopify.getBlog("sales-events", this.salesEventsGot);

    jQuery('.share-btn').click(function(e){
        e.preventDefault();
        var url = this.href,
				w = 500,
				h = 400,
				left = (screen.width / 2) - (w / 2),
				top = (screen.height / 2) - (h / 2);

			window.open(url, '', 'toolbar=no, location=no, directories=no, status=no,' +
				' menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
    });


  },

  styleTipsGot: function(posts) {
    if ('style-tips' == this.props.routeParams.blogType) {
      this.fillInContent(posts);     
    }
    var p = posts[0];
    p.postType = "Style Tips";

    if (this.relatedForSaleEvent) {
      this.refs.postRow.setPosts([p, this.relatedForSaleEvent])
    } else {
      this.relatedForStyleTip = p;
    }
    /*
    this.refs.postRow.setPosts(_.map(_.take(posts, 2),
                                     function(post) {
                                       post.postType = "Style Tips";
                                       return post;
                                     }));
    */
  },

  salesEventsGot: function(posts) {
    if ('sales-events' == this.props.routeParams.blogType) {
      this.fillInContent(posts);
    }
    var p = posts[0];
    p.postType = "Sales Event";

    if (this.relatedForStyleTip) {
      this.refs.postRow.setPosts([this.relatedForStyleTip, p])
    } else {
      this.relatedForStyleTip = p;
    }
  },     

  fillInContent: function(posts) {
    var postForThisPage = _.filter(posts,
                                   function(post) {
                                     var pType = this.props.routeParams.blogType;
                                     var indexHandle = post.url.indexOf(pType) + pType.length + 1;
                                     var postHandle = post.url.substring(indexHandle); 
                                     return postHandle == this.props.params.postHandle;
                                   }.bind(this))[0];
    var content = Utils.reconstructPost(postForThisPage.content);
    this.refs.headerPage.setContent("- " + this.props.params.blogType + " -",
                                    postForThisPage.img,
                                    postForThisPage.title,
                                    "");

    this.setState({ postTitle: postForThisPage.title });

    jQuery(this.refs.content).append(content.allContent());
  },

  render: function() {
    var shareUrl = window.location.href;
    var url_encoded = encodeURIComponent(shareUrl);
    
    return <div>
            <div className="container breadcrumb hidden-xs">
                <Link to={"/pages/style-tips"} >{this.props.params.blogType}</Link>
                <span>&nbsp;&nbsp;&gt;&nbsp;&nbsp;{this.state.postTitle}</span>
            </div>
            <div className="container breadcrumb-m visible-xs-block">
                <Link to={"/pages/style-tips"} >&lt; BACK TO STYLE TIPS</Link>
            </div>
            <HeaderPage ref="headerPage" />
            <main id="content" className="container" role="main">
                <article className="row post-content">
                    <div className="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">
                        <div  ref="content" />
                        <div className="socials">
                            <a role="button" className="share-btn" href={'https://facebook.com/sharer.php?u=' + url_encoded}>like on facebook</a>
                            <span>&nbsp;&nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <a role="button" className="share-btn" href={'https://twitter.com/intent/tweet?url=' + url_encoded}>share on twitter</a>
                        </div>
                    </div>
                </article>
                <section className="related-stories">
                    <p className="lead">- keep reading -</p>
                    <h1>related stories</h1>
                    <PostRow ref="postRow" />
                </section>
            </main>
        </div>
  }
});